export const ContentLogo = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <a href="/">
        <img src="/img/logo.png" alt="Logo" className="logo" />
      </a>
    </div>
  );
};